import { Injectable } from '@angular/core';

import { select, Store, Action } from '@ngrx/store';

import * as EventsActions from './events.actions';
import * as EventsFeature from './events.reducer';
import * as EventsSelectors from './events.selectors';

@Injectable()
export class EventsFacade {
  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */
  loaded$ = this.store.pipe(select(EventsSelectors.getEventsLoaded));
  allEvents$ = this.store.pipe(select(EventsSelectors.getAllEvents));
  selectedEvents$ = this.store.pipe(select(EventsSelectors.getSelected));

  constructor(private store: Store) {}

  /**
   * Use the initialization action to perform one
   * or more tasks in your Effects.
   */
  init() {
    this.store.dispatch(EventsActions.init());
  }
}
